import { Box, Button, Grid, styled } from "@mui/material";
import heroImage from "../resources/images/home/hero-image.png";
import theme from "../app/app-theme";
import { useState } from "react";
import RegistrationForm from "./table/registration-form";
import aboutBackground from "../resources/images/home/background.jpg";

const HeroBox = styled(Box)({
    display: 'flex',
    minHeight: `100vh`,
    backgroundImage: `url(${aboutBackground})`,
    backgroundSize: 'cover',
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down('sm')]: {
        backgroundPosition: "right",
    }
})

const TextHeading = styled('h1')({
    color: `white`,
    fontSize: '64px',
    fontWeight: 'bold',
    textAlign: 'center'
});

const TextDescription = styled('h4')({
    color: `gold`,
    fontSize: '28px',
    lineHeight: '1.5',
    textAlign: 'center'
});

const Hero = () => {
    const [showRegistrationForm, setShowRegistrationForm] = useState(false);

    return (
        <HeroBox sx={{ minHeight: '100vh', p: 4, display: 'flex', flexDirection: 'column', rowGap: 4 }} >
            <Grid container spacing={{ xs: 1, md: 2 }}
                sx={{ flexGrow: 1 }}>
                <>
                    <Grid sx={{ flexGrow: 1, position: 'relative', top: -60 }} container size={{ md: 6, xs: 12 }} justifyContent="center" alignItems="center">
                        <div className="text-center">
                            <TextHeading>Minimize Effort, Maximize Efficiency</TextHeading>
                            <TextDescription>Fitness center management software for increased organization and efficiency designed for gym owners</TextDescription>
                        </div>
                        <div>
                            <Button
                                variant="contained"
                                size="large"
                                sx={{ backgroundColor: `${theme.palette.error.dark}`, height: "60px", width: "200px", fontSize: "20px" }}
                                onClick={() => { setShowRegistrationForm(true) }}
                            >
                                Register Now
                            </Button>
                        </div>

                    </Grid>
                    <Grid sx={{ flexGrow: 1, top: -30 }} container size={{ md: 6, xs: 12 }} justifyContent="start" alignItems="start">
                        <img src={heroImage} style={{ maxWidth: "100%" }} alt="" />
                    </Grid>
                </>
            </Grid>
            {showRegistrationForm &&
                <RegistrationForm onClose={() => setShowRegistrationForm(false)} />
            }
        </HeroBox>
    );
}

export default Hero;